import React from 'react';
import { VaLoadingIndicator } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import LoginActions from 'platform/user/authentication/components/LoginActions';
import { EXTERNAL_APPS } from 'platform/user/authentication/constants';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';

const ArpLoginActions = () => {
  const { useToggleLoadingValue } = useFeatureToggle();
  const isPivSigninLoading = useToggleLoadingValue();

  // The toggle state can be undefined before the feature flag request resolves.
  // Treat that as loading so the shared login buttons do not flash before the
  // ARP-specific sign-in flow is ready.
  if (isPivSigninLoading !== false) {
    return <VaLoadingIndicator />;
  }

  return <LoginActions externalApplication={EXTERNAL_APPS.ARP} isUnifiedSignIn />;
};

export default ArpLoginActions;
